import BranchesPage from "../pages/BranchesPage";
import ComplaintPage from "../pages/ComplaintPage";
import ContactPage from "../pages/ContactPage";
import DownloadAppPage from "../pages/DownloadAppPage";
import HomePage from "../pages/Home";
import Layout from "../layouts";
import NewBranchPage from "../pages/NewBranch/NewBranchPage";
import NewPage from "../pages/NewPage";
import NewsPage from "../pages/NewsPage";
import StatisticsPage from "../pages/StatisticsPage";

const routes = () => {

	return [
		
	    {
			path:'/home',
			element: <Layout/>,
            children: [
				{ path:'/home',element: <HomePage /> },	
				{ path:'download',element: <DownloadAppPage /> },	
				{ path:'complaint',element: <ComplaintPage /> },
				{ path:'news',element: <NewsPage /> },
				{ path:'new/:id',element: <NewPage /> },
				{ path:'branches',element: <BranchesPage /> },
				{ path:'contact/:id',element: <ContactPage /> },
				{ path:'statistics',element: <StatisticsPage /> },
				{ path:'newbranch',element: <NewBranchPage /> },


			],
		},
	    {
			path:'/',
			element: <Layout/>,
            children: [
				{ path:'home',element: <HomePage /> },	
				


			]
        
		},
	   
	

		

	];
};


export default routes;
